import { render, staticRenderFns } from "./SalgProdukter.vue?vue&type=template&id=5e325e1c&scoped=true&"
var script = {}
import style0 from "./SalgProdukter.vue?vue&type=style&index=0&id=5e325e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e325e1c",
  null
  
)

export default component.exports